import { observer } from 'mobx-react';
import { useEffect, useMemo } from 'react';
import { MENU_GROUPS_COLUMN_NAME } from '../../../MenuGroupsScreen/types/menuGroups';
import MenuGroupImprovementListRow from '../MenuGroupImprovementListRow/MenuGroupImprovementListRow';
import menuGroupImprovementStore from '../../store/menuGroupImprovementStore';
import EmptyScreen from '../EmptyScreen/EmptyScreen';
import { localeStore } from 'src/mobx/localesStore';
import { emptyArray } from 'src/utils/helpers';
import ColumnTitle from 'src/view/components/ColumnTitle/ColumnTitle';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';

const MenuGroupImprovementList = observer((): JSX.Element => {
  useEffect(() => {
    return () => {
      menuGroupImprovementStore.resetMenuGroupImprovementList();
    };
  }, []);

  const menuGroupImprovementListRow = useMemo(() => {
    if (menuGroupImprovementStore.isLoading) {
      return emptyArray().map((_, index) => <MenuGroupImprovementListRow key={'key-' + String(index)} />);
    }
    return menuGroupImprovementStore.menuGroupImprovementList?.map((menuGroupImprovement) => (
      <MenuGroupImprovementListRow key={menuGroupImprovement.id} menuGroupImprovement={menuGroupImprovement} />
    ));
  }, [menuGroupImprovementStore.isLoading, menuGroupImprovementStore.menuGroupImprovementList]);

  if (!menuGroupImprovementStore.menuGroupImprovementList?.length) {
    return <EmptyScreen />;
  }

  return (
    <div className="d-flex flex-column flex-grow-1 pt-4">
      <div className="d-flex flex-row mb-4 pr-5">
        <ColumnTitle<MENU_GROUPS_COLUMN_NAME> title={localeStore.t('menu_healthchecker_issues_list_col')} className="w-40" />
        <ColumnTitle<MENU_GROUPS_COLUMN_NAME> title={localeStore.t('url_link')} className="w-30" />
      </div>
      <ScrollableBlock showScrollbar scrollClassName="d-flex flex-column full-height pr-4" className="mb-3">
        {menuGroupImprovementListRow}
      </ScrollableBlock>
    </div>
  );
});

export default MenuGroupImprovementList;
